import { createIcon } from '../utils';

export const ClockFastIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.375 12.75H16.125L12.375 16.5H16.125M16.463 9.75C16.4875 9.50332 16.5 9.25312 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C9.12575 16.5 9.25077 16.4969 9.375 16.4908C9.50084 16.4846 9.62587 16.4753 9.75 16.463M9 4.5V9L11.8038 10.4019"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'ClockFastIcon', defaultSize: 18 },
);
